<div *ngIf="showReviewsAndRatings">
    <div class="padding-div">
        <div class="d-flex justify-content-center rating-title">
            <p>
                Reviews and Ratings
            </p>
        </div>
        <div class="title-underline">
            &nbsp;
        </div>
        <div class="dish-name">
            {{foodDishName}}
        </div>
        <div class="d-flex">
            <div class="write-your-review">
                Write your review
            </div>
            <div class="edit-rating">
                <img src="assets/img/ratings-edit.svg" alt="" (click)="GoToReviewspage(foodDishName)">
            </div>
        </div>
    </div>

    <div class="taste-ratings-div" (click)="gotoTasteRatingsPage(foodDishName)" style="cursor: pointer;">
        <div class="d-flex space-between">
            <div class="taste-ratings-reviews">
                Taste Ratings & Reviews
            </div>
            <div class="ratings-count" >
                {{total_rating_count}} ratings & {{total_review_count}} reviews <span><img src="../../../../assets/img/right-icons.svg" alt=""
                        (click)="gotoTasteRatingsPage(foodDishName)"></span>
            </div>
        </div>
    </div>

    <div class="padding-div">
        <div class="d-flex space-between">
            <div>
                <mat-radio-button color="primary" style="padding-left: 10px" (click)="checkOverAll()" [checked]='true'>
                    Overall
                </mat-radio-button>
            </div>
            <div>
                <mat-radio-button color="primary" style="padding-left: 10px" (click)="checkPersonalized()"> Personalised
                </mat-radio-button>
            </div>
            <div ngbTooltip="This is unsuitable as per your dietary preferences" placement="bottom" triggers="hover">
                <button class="btn-allergen" type="button"><img src="assets/img/hover-icon.svg" alt=""></button>
            </div>
        </div>

        <div class="d-flex excellent-div">
            <div class="star-icon">
                <img src="assets/img/start-icon.svg" alt="">
            </div>
            <div *ngIf="overallBool">
                <span class="ratings-count-number">{{overAllRating}}</span> <em class="excellent">{{overAllText}}</em>
            </div>
            <div *ngIf="personalisedBool">
                <span class="ratings-count-number">{{personalisedRating}}</span> <em
                    class="excellent">{{personalised_text}}</em>
            </div>
        </div>
    </div>

    <div class="allergy-ratings-div" (click)="gotoAllergyRatingsPage(foodDishName)" style="cursor: pointer;">
        <div class="d-flex space-between">
            <div class="taste-ratings-reviews">
                Allergy Ratings
            </div>
            <div class="ratings-count">
                View all <span><img src="../../../../assets/img/right-icons.svg" alt=""
                        ></span>
            </div>
        </div>
    </div>

    <div class="padding-div">
        <div class="d-flex">
            <div class="zero-padding">
                <div class="zero-out-zero">
                    {{review_total}} out of {{review_total}}
                </div>
                <div class="safe-text">
                    <em>Found this {{review_code}}</em>
                </div>
            </div>

            <div class="d-flex margl-10 ">
                <div class="people-with-allergy">
                    People with Allergy
                </div>
                <div class="margl-10 ">
                    <ng-select [(ngModel)]="allergenss_name" name="allergenss_name" [items]="allergensListArray"
                        bindLabel="allergens_name" bindValue="allergens_id" [multiple]="false" [clearable]="false"
                        [virtualScroll]="true">
                    </ng-select>
                </div>
            </div>
        </div>
    </div>
</div>

<div *ngIf="!showReviewsAndRatings">
    <div class="padding-div">
        <div class="d-flex justify-content-center rating-title">
            <p>
                Reviews and Ratings
            </p>
        </div>
        <div class="title-underline">
            &nbsp;
        </div>
        <div class="dish-name">
            {{foodDishName}}
        </div>
        <div class="d-flex">
            <div class="write-your-review">
                Write your review
            </div>
            <div class="edit-rating">
                <img src="assets/img/ratings-edit.svg" alt="" (click)="GoToReviewspage(foodDishName)">
            </div>
        </div>
        <div style="padding-left:10px;padding-top:10px">
            No Ratings and Reviews found for this dish.
        </div>
    </div>
</div>
<style>
    ::ng-deep.mat-bottom-sheet-container {
        padding: 0px !important;
        box-sizing: border-box;
        display: block;
        outline: 0;
        overflow: auto;
        border-top-left-radius: 16px !important;
        border-top-right-radius: 16px !important;
    }

    ::ng-deep.mat-bottom-sheet-container-large {
        min-width: 380px;
        max-width: 380px;
    }

    ::ng-deep.mat-bottom-sheet-container-xlarge {
        min-width: 380px !important;
        max-width: 380px;
    }

    .rating-title {
        color: #54AC58;
        font-size: 18px;
        line-height: 23px;
        font-weight: 450;
    }

    .title-underline {
        border-bottom: 3px solid #EFEFEF;
    }

    .dish-name {
        color: #4E4E4E;
        font-size: 16px;
        line-height: 19px;
        font-weight: 500;
        padding: 10px 0px 0px 10px;
    }

    .write-your-review {
        font-size: 14px;
        font-family: 'Roboto';
        line-height: 19px;
        color: #242323;
        font-weight: 400;
        padding: 10px 0px 0px 10px;
    }

    .padding-div {
        padding: 20px;
    }

    .taste-ratings-div {
        background: #F2F5F7;
        padding: 9px 30px 7px 30px;
    }

    .taste-ratings-reviews {
        color: #707070;
        font-size: 14px;
        letter-spacing: 0.3px;
        line-height: 19px;
        font-family: 'Roboto';
        font-weight: 450;
    }

    .space-even {
        justify-content: space-evenly;
    }

    .ratings-count {
        color: #707070;
        font-size: 11px;
        line-height: 15px;
        font-family: 'Roboto';
        padding-top: 3px;
    }

    .ratings-count img {
        margin-left: 10px;
    }

    ::ng-deep .mat-radio-button.mat-primary.mat-radio-checked .mat-radio-outer-circle {
        border-color: #54AC58;
    }

    ::ng-deep .mat-radio-button.mat-primary .mat-radio-inner-circle {
        background-color: #54AC58;
    }

    ::ng-deep.mat-radio-outer-circle {
        width: 18px !important;
        height: 18px !important;
    }

    ::ng-deep.mat-radio-inner-circle {
        width: 18px !important;
        height: 18px !important;
    }

    ::ng-deep .mat-radio-label-content {
        -webkit-user-select: auto;
        -moz-user-select: auto;
        -ms-user-select: auto;
        user-select: auto;
        display: inline-block;
        order: 0;
        color: #4E4E4E !important;
        line-height: inherit;
        padding-left: 10px !important;
        padding-right: 0;
        font-size: 13px;
        line-height: 18px;
    }

    .space-between {
        justify-content: space-between;
    }

    .excellent {
        color: #707070;
        font-size: 13px;
        line-height: 18px;
    }

    .btn-allergen {
        border: none;
        background: transparent;
    }

    .btn-allergen img {
        width: 18px;
        margin-top: -7px;
    }

    .edit-rating img {
        margin: 5px 0px 0px 20px;
        cursor: pointer;
    }

    .star-icon img {
        width: 15px;
        margin-left: 8px;
        margin-top: -3px;
    }

    .ratings-count-number {
        color: #707070;
        font-size: 13px;
        line-height: 18px;
        font-family: 'Roboto';
        font-weight: 450;
        padding: 5px 5px 0px 5px;
    }

    ::ng-deep.tooltip-inner {
        background-color: #F4FFF4 !important;
        width: 174px !important;
        height: 52px !important;
        border-radius: 9px !important;
        box-shadow: 3px #62626226;
        color: #4e4e4e !important;
        /* margin-left: -38%; */
        font-family: "Roboto";
        font-size: 14px;
        box-shadow: -3px 3px 6px rgba(98, 98, 98, 0.15);
    }

    .btn-select:focus {
        box-shadow: none !important;
    }

    .btn-select {
        border: none;
        background: transparent;
    }

    ::ng-deep .bs-tooltip-bottom .arrow::before {
        bottom: 0;
        border-width: 0px 10px 11px !important;
        border-bottom-color: #F4FFF4 !important;
    }

    .excellent-div {
        padding-top: 10px;
    }

    .allergy-ratings-div {
        background: #F2F5F7;
        padding: 9px 30px 7px 30px;
    }

    .zero-out-zero {
        border: 1px solid #54AC58;
        background: #F4FFF4;
        color: #4E4E4E;
        font-size: 13px;
        line-height: 18px;
        font-family: 'Roboto';
        font-weight: 400;
        border-radius: 15px;
        padding: 3px;
        width: 99px;
        height: 26px;
        text-align: center;
    }

    ::ng-deep.ng-select.ng-select-single .ng-select-container {
        width: 100px;
        height: 26px;
        border: 1px solid #FA4747;
    }

    .people-with-allergy {
        color: #4E4E4E;
        font-size: 13px;
        line-height: 18px;
        font-family: 'Roboto';
        font-weight: 400;
    }

    .margl-10 {
        margin-left: 10px;
    }

    ::ng-deep.ng-select .ng-select-container {
        color: #333;
        border-radius: 15px !important;
        border: 1px solid #DDDDDD;
        min-height: 26px;
        align-items: center;
    }

    .safe-text {
        color: #707070;
        font-size: 14px;
        line-height: 19px;
        font-family: 'Roboto';
    }

    .zero-padding {
        padding-left: 10px;
    }

    .ratings-count img {
        cursor: pointer;
    }
</style>